// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"2":"f7bf79cb","25":"f7bf79cb","34":"f7bf79cb","256":"f7bf79cb","442":"f7bf79cb","591":"f7bf79cb","615":"f7bf79cb","724":"7914bb3f","976":"f7bf79cb","985":"abd498a4"}[chunkId] + ".chunk.css";
};